import { render, staticRenderFns } from "./gl-loader.vue?vue&type=template&id=397fd0e1&"
import script from "./gl-loader.vue?vue&type=script&lang=js&"
export * from "./gl-loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports